import { TopToolbar, ListButton } from 'react-admin';
import { DashboardResources } from '@src/types';

/**
 * Custom actions for variant SKU edit view
 * Includes back to catalog list button
 */
export const VariantSkuEditActions = () => (
  <TopToolbar>
    <ListButton resource={DashboardResources.CatalogItems} label="Back to Catalog" />
  </TopToolbar>
);
